import { apiPaymentGuest } from '../../core/redux/api/endpoints';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import * as R from 'ramda';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { PaymentGuest } from './paymentGuest';


const KEY_ACTION = ACTION_TYPE.GET_PAYMENT_GUEST_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_PAYMENT_GUEST_REQUEST,
  ACTION_TYPE.GET_PAYMENT_GUEST_RESPONSE,
  ACTION_TYPE.GET_PAYMENT_GUEST_ERROR
];


/**
 * Constructs a payment guest search Redux Action for submitting the given query to the REST API
 * @param query - The query to search, this will be escaped for you.
 */
export const getPaymentGuestAction = (guestId: string) => makeApiAction(
  {
    method:   'GET',
    endpoint: state => apiPaymentGuest(guestId),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { guestId } })) as RsaaTypes,
    // Bail if we're already loading results for that query
    bailout:  (state: IAppState) => !!getLoading(state, guestId, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<PaymentGuest> = (state, action, error, isLoading, payload): IAppState => {
  const guestId = action.meta.guestId;

  if (isLoading) {
    return addLoading(state, guestId!, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);
  
  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, guestId!, KEY_ACTION);

  const paymentGuests = noLoadingOrError.paymentGuests === undefined ? [] : noLoadingOrError.paymentGuests;

  if (payload && paymentGuests.filter((guest) => guest.masterGuestId === guestId).length === 0) {
    return R.assocPath(['paymentGuests'], 
        paymentGuests.concat({
        masterGuestId: guestId,
        firstName: payload.firstName,
        lastName: payload.lastName,
        photoData: payload.photoData,
    } as PaymentGuest), noLoadingOrError);
  }

  return noLoadingOrError;
};

export const getPaymentGuestReducer = makeApiReducer<PaymentGuest>(ACTIONS, KEY_ACTION, reducer);
